import { render, staticRenderFns } from "./chat-sidebar-recents.vue?vue&type=template&id=70f5c458&scoped=true&"
import script from "./chat-sidebar-recents.vue?vue&type=script&lang=js&"
export * from "./chat-sidebar-recents.vue?vue&type=script&lang=js&"
import style0 from "./chat-sidebar-recents.vue?vue&type=style&index=0&id=70f5c458&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f5c458",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70f5c458')) {
      api.createRecord('70f5c458', component.options)
    } else {
      api.reload('70f5c458', component.options)
    }
    module.hot.accept("./chat-sidebar-recents.vue?vue&type=template&id=70f5c458&scoped=true&", function () {
      api.rerender('70f5c458', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/chat-sidebar-recents/chat-sidebar-recents.vue"
export default component.exports